/**
 * 采用自执行函数与命名空间方式挂载，确保全局可用且避免命名冲突
 */
(function (global) {
  // 检查是否已经存在，避免重复定义
  if (global.MomcozyUtils && global.MomcozyUtils.BrowserUtil) {
    return global.MomcozyUtils.BrowserUtil;
  }

  // 创建命名空间
  global.MomcozyUtils = global.MomcozyUtils || {};

  // 定义 BrowserUtil
  const BrowserUtil = {
    /**
     * 设置 Cookie
     * @param {string} name - Cookie 名称
     * @param {string} value - Cookie 值
     * @param {Object} [options] - 配置选项
     * @param {number} [options.days] - 过期天数
     * @param {number} [options.hours] - 过期小时数
     * @param {number} [options.minutes] - 过期分钟数
     * @param {number} [options.seconds] - 过期秒数
     * @param {string} [options.path] - 路径，默认为 '/'
     * @param {string} [options.domain] - 域名
     * @param {boolean} [options.secure] - 是否仅 HTTPS
     * @param {string} [options.sameSite] - SameSite 属性 (Lax/Strict/None)
     */
    set(name, value, options = {}) {
      let cookieText = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;

      // 处理过期时间
      if (options.days || options.hours || options.minutes || options.seconds) {
        const expires = new Date();
        if (options.days) expires.setDate(expires.getDate() + options.days);
        if (options.hours) expires.setHours(expires.getHours() + options.hours);
        if (options.minutes) expires.setMinutes(expires.getMinutes() + options.minutes);
        if (options.seconds) expires.setSeconds(expires.getSeconds() + options.seconds);
        cookieText += `; expires=${expires.toUTCString()}`;
      }

      // 设置路径，默认为根路径
      cookieText += `; path=${options.path || '/'}`;

      if (options.domain) {
        cookieText += `; domain=${options.domain}`;
      }

      if (options.secure) {
        cookieText += '; secure';
      }

      if (options.sameSite) {
        cookieText += `; SameSite=${options.sameSite}`;
        if (options.sameSite.toLowerCase() === 'none') {
          cookieText += '; secure';
        }
      }

      document.cookie = cookieText;
    },

    /**
     * 获取 Cookie 值
     * @param {string} name - 要获取的 Cookie 名称
     * @returns {string|null} - Cookie 值，不存在时返回 null
     */
    get(name) {
      const cookieName = `${encodeURIComponent(name)}=`;
      const cookies = document.cookie.split(';');

      for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i].trim();
        if (cookie.indexOf(cookieName) === 0) {
          return decodeURIComponent(cookie.substring(cookieName.length, cookie.length));
        }
      }

      return null;
    },

    /**
     * 删除 Cookie
     * @param {string} name - 要删除的 Cookie 名称
     * @param {string} [path] - 路径，默认为 '/'
     * @param {string} [domain] - 域名
     */
    remove(name, path, domain) {
      this.set(name, '', {
        path: path || '/',
        domain,
        seconds: -1,
      });
    },

    /**
     * 检查 Cookie 是否存在
     * @param {string} name - 要检查的 Cookie 名称
     * @returns {boolean} - 是否存在
     */
    has(name) {
      return this.get(name) !== null;
    },

    /**
     * 获取所有 Cookie 名称
     * @returns {string[]} - Cookie 名称数组
     */
    keys() {
      const cookies = document.cookie.split(';');
      return cookies.map((cookie) => {
        return decodeURIComponent(cookie.trim().split('=')[0]);
      });
    },
    getRootDomain(url) {
      const parsedUrl = new URL(url);
      const { hostname } = parsedUrl;
      // 检查是否为IP地址
      const isIpAddress = /^\d{1,3}(\.\d{1,3}){3}$/.test(hostname);
      if (isIpAddress) {
        return hostname;
      }
      const domainParts = hostname.split('.');
      const rootDomain = domainParts.slice(Math.max(domainParts.length - 2, 0)).join('.');
      return rootDomain;
    },
    hasUrlParam(paramName) {
      const query = window.location.search.substring(1);
      const params = query.split('&');
      for (const param of params) {
        const [key, _] = param.split('=');
        if (key === paramName) return true;
      }
      return false;
    },
    getUrlParam(paramName) {
      const searchParams = new URLSearchParams(window.location.search);
      return searchParams.get(paramName);
    },
  };

  // 将 BrowserUtil 挂载到命名空间
  global.MomcozyUtils.BrowserUtil = BrowserUtil;

  // 兼容旧代码，也可以直接挂载到 global，但不推荐
  if (!global.BrowserUtil) {
    global.BrowserUtil = BrowserUtil;
  }

  // 返回 BrowserUtil 对象
  return BrowserUtil;
})(typeof window !== 'undefined' ? window : this);

if (window.MomcozyUtils && window.MomcozyUtils.BrowserUtil) {
  if (window.MomcozyUtils.BrowserUtil.hasUrlParam('linkCode')) {
    const linkCode = window.MomcozyUtils.BrowserUtil.getUrlParam('linkCode');
    window.MomcozyUtils.BrowserUtil.set('linkCode', linkCode, {
      days: 7,
      domain: window.MomcozyUtils.BrowserUtil.getRootDomain(window.location.href),
    });
  }
}

